import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import PriceStructureSection from "./components/PriceStructureSection";
import MonthlySupportSection from "./components/MonthlySupportSection";
import InitialSupportSection from "./components/InitialSupportSection";
import ProductionDevSection from "./components/ProductionDevSection";
import MaintenanceSection from "./components/MaintenanceSection";
import ScopeSection from "./components/ScopeSection";
import PriceFactorsSection from "./components/PriceFactorsSection";
import PlanExamplesSection from "./components/PlanExamplesSection";
import EstimateFlowSection from "./components/EstimateFlowSection";
import ContractSection from "./components/ContractSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function PricingPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <PriceStructureSection />
      <MonthlySupportSection />
      <InitialSupportSection />
      <ProductionDevSection />
      <MaintenanceSection />
      <ScopeSection />
      <PriceFactorsSection />
      <PlanExamplesSection />
      <EstimateFlowSection />
      <ContractSection />
      <FAQSection />
      <CTASection />
    </>
  );
}